import React from 'react'
import { SwiperSlide } from 'swiper/react'
import SwiperSlider from '../../Swiper/SwiperSlider'
import { Navigation } from 'swiper/modules'
import style from './FeatureCategories.module.css'
import Category from '../../Home/Category/Category'

interface FeatureCategoriesProps {
	featured_categories: any
}

const FeatureCategories: React.FC<FeatureCategoriesProps> = ({ featured_categories }) => {
	return (
		<section className={`${style.featuredCategories} pt-14 pb-28`}>
			<div className='featured-category-wrapper width'>
				<div className='mt-6 w-full'>
					<SwiperSlider
						navigation={true}
						modules={[Navigation]}
						spaceBetween={30}
						slidesPerView={1}
						slidesPerGroup={1}
						loop={true}
						speed={1500}
						autoplay={false}
						pagination={false}
						className={'custSwiper'}
						breakpoints={{
							1440: {
								slidesPerView: 5,
								slidesPerGroup: 5
							},
							1024: {
								slidesPerView: 4,
								slidesPerGroup: 4
							},
							786: {
								slidesPerView: 3,
								slidesPerGroup: 3
							},
							575: {
								slidesPerView: 2,
								slidesPerGroup: 2
							}
						}}
					>
						{featured_categories?.map((category: any, index: number) => (
							<SwiperSlide key={index} className='px-4'>
								<Category category={category} />
							</SwiperSlide>
						))}
					</SwiperSlider>
				</div>
			</div>
		</section>
	)
}

export default FeatureCategories
